import { routes } from "./routes.js";
import { createRouter, createWebHistory } from "vue-router";
import { trackRouter } from "vue-gtag-next";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

trackRouter(router);

export default router;
